import { Box } from '@mui/material';
import 'swiper/css';
import { Lazy, Navigation, Pagination } from 'swiper';

import 'swiper/css/navigation';
import 'swiper/css/pagination';
import styled from '@emotion/styled';

import React, { useState } from 'react';
import SwiperButton from '@/assets/pdp/offerSwiperButton.svg';
import SwiperButtonDisabled from '@/assets/pdp/offerSwiperButton2.svg';
import { ICarousel } from '../model';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { getColor } from '@/utils/theme/colors';
import LencoButton from '@/atomic-components/LencoButton';

const CustomDiv = styled(Box)`
	max-width: 1440px;
	width: 100%;
	position: relative;
	.LencoSwiper .swiper {
		position: relative;
	}

	.LencoSwiper .swiper-slide {
		border-radius: 8px;
		overflow: hidden;
	}

	.LencoSwiper .swiper-button-prev {
		top: 50px;
		left: 0;
	}

	.LencoSwiper .swiper-button-next::after {
		display: none;
	}
`;

const OfferCarousel = (props: ICarousel & { isLeftAligned?: boolean }) => {
	const swiperRef = React.useRef<SwiperRef>(null);

	const [prevButtonvalue, setPrevButtonValue] = useState(true);
	const [nextButtonvalue, setNextButtonValue] = useState(true);
	const totalSlidesOnView = props?.slidesPerView ? props?.slidesPerView : 2;
	const checkToScrollOnPrevSwipe = (e: any) => {
		e.stopPropagation();
		setNextButtonValue(true);

		if (swiperRef?.current?.swiper?.snapIndex) {
			swiperRef?.current?.swiper?.snapIndex != 1
				? swiperRef?.current?.swiper?.slidePrev()
				: setPrevButtonValue(false);
		}
	};
	const checkToScrollOnNextSwipe = (e: any) => {
		e.stopPropagation();
		setPrevButtonValue(true);
		if (swiperRef?.current?.swiper?.snapIndex) {
			swiperRef?.current?.swiper?.snapIndex != 3
				? swiperRef?.current?.swiper?.slideNext()
				: setNextButtonValue(false);
		}
	};
	return (
		<CustomDiv>
			{swiperRef && (
				<LencoButton
					disabled={
						swiperRef?.current?.swiper?.snapIndex == 1 + totalSlidesOnView
					}
					onClick={(e) => {
						checkToScrollOnPrevSwipe(e);
					}}
					sx={{
						transform: 'rotate(180deg)',
						position: 'absolute',
						zIndex: 9,
						top: '10%',
						left: '-25px',
						tranform: 'translate(-50%)',
						cursor: 'pointer',
					}}
				>
					{prevButtonvalue ? <SwiperButton /> : <SwiperButtonDisabled />}
				</LencoButton>
			)}

			<Swiper
				ref={swiperRef}
				modules={[Navigation, Lazy, Pagination]}
				className='LencoSwiper'
				loop={true}
				spaceBetween={props.spaceBetween}
				slidesPerView={props.slidesPerView}
				pagination={props.dots}
				centeredSlides={props?.centered}
			>
				{props?.children?.map((d, index) => {
					return <SwiperSlide key={index}>{d}</SwiperSlide>;
				})}
			</Swiper>
			{swiperRef && (
				<LencoButton
					id='nextButton'
					disabled={
						swiperRef?.current?.swiper?.snapIndex ==
						props.children?.length! + totalSlidesOnView
					}
					onClick={(e) => {
						checkToScrollOnNextSwipe(e);
					}}
					sx={{
						position: 'absolute',
						tranform: 'translate(-50%)',
						zIndex: 9,
						top: '15%',
						right: '-25px',
						cursor: 'pointer',
					}}
				>
					{nextButtonvalue ? <SwiperButton /> : <SwiperButtonDisabled />}
				</LencoButton>
			)}
		</CustomDiv>
	);
};

export default OfferCarousel;
